import React from 'react';
import {
  useSelectCoverQuery,
  useSearchUnsplashQuery,
} from '@trello/graphql/generated';
import { forTemplate } from 'app/common/lib/util/i18n';
import { SearchResultImageButton } from './SearchResultImageButton';
import { unsplashClient } from '@trello/unsplash';
import {
  Analytics,
  Action,
  Source,
  ActionSubject,
  ActionSubjectId,
} from '@trello/atlassian-analytics';
import styles from './TopUnsplashPhotos.less';

const format = forTemplate('card_cover_chooser');

interface TopUnsplashPhotosProps {
  cardId: string;
  onSetCover: () => void;
}

export const TopUnsplashPhotos: React.FunctionComponent<TopUnsplashPhotosProps> = ({
  cardId,
  onSetCover,
}) => {
  const { data: topPhotosData } = useSearchUnsplashQuery({
    variables: {
      query: '',
      perPage: 9,
      page: 1,
    },
    fetchPolicy: 'cache-only',
  });

  const { data: cardData } = useSelectCoverQuery({
    variables: { cardId },
    fetchPolicy: 'cache-only',
  });

  const card = cardData?.card;
  const containers = {
    organization: {
      id: card?.board.idOrganization,
    },
    board: {
      id: card?.board.id,
    },
    card: {
      id: card?.id,
    },
  };

  const topPhotos =
    topPhotosData && topPhotosData.unsplashPhotos
      ? topPhotosData.unsplashPhotos
      : [];

  if (!topPhotos.length) {
    return null;
  }

  return (
    <div>
      <h4 className={styles.heading}>{format('top-photos')}</h4>
      <div className={styles.unsplashTiles}>
        {topPhotos.slice(0, 12).map(({ urls, links, user, id }, index) => (
          <SearchResultImageButton
            key={id}
            urls={urls}
            links={links}
            user={user}
            index={index}
            cardId={cardId}
            onSetCover={onSetCover}
            onSetCoverFailed={() => {}}
            buttonClassName={styles.unsplashTilesItem}
            onClick={() =>
              Analytics.sendUIEvent({
                action: Action.clicked,
                actionSubject: ActionSubject.tile,
                actionSubjectId: ActionSubjectId.cardCoverUnsplashTile,
                source: Source.cardCoverInlineDialog,
                attributes: {
                  value: urls.raw,
                },
                containers,
              })
            }
          />
        ))}
      </div>

      <div className={styles.searchResultsFooter}>
        <div className={styles.unsplashColumn}>
          {format('photos-from-unsplash', {
            unsplashLink: (
              <a
                key="a"
                className={styles.unsplashLink}
                href={unsplashClient.attributionUrl}
                rel="noreferrer noopener"
                target="_blank"
              >
                Unsplash
              </a>
            ),
          })}
        </div>
      </div>
    </div>
  );
};
